import en from './en'

const language = {
    ENGLISH: 'English',
    BULGARIAN: 'Български',
    ROMANIAN: 'Romanian',
}

const country = {
    BULGARIA: 'Bulgaria',
    ROMANIA: 'Romania',
}

const navigation = {
    NAVIGATION_HOME: 'Home',
    NAVIGATION_TEAM: 'Team',
    NAVIGATION_STATISTICS: 'Статистика',
    NAVIGATION_SETTINGS: 'Settings',
    NAVIGATION_QR: 'QR-code',
    NAVIGATION_HELP: 'Помощ',
}

const header = {
    HEADER_LOGOUT: 'Излез',
}

const onboarding = {
    ONBOARDING_STEP: 'Стъпка',
    ONBOARDING_STEP_REGISTRATION: 'Регистрация',
    ONBOARDING_STEP_EMAIL: 'Потвърждение на имейл',
    ONBOARDING_STEP_STRIPE: 'Stripe',

    ONBOARDING_EMAIL_DESCRIPTION:
        'Изпратихме Ви имейл с код за потвърждение на',
    ONBOARDING_ENTER_CODE: 'ВЪВЕДЕТЕ КОДА ОТ ИМЕЙЛА',
    ONBOARDING_SEND_CODE_AGAIN: 'Изпратете кода отново',
    ONBOARDING_INCORRECT_CODE: 'НЕПРАВИЛЕН КОД',
    ONBOARDING_BACK: 'ОБРАТНО',

    ONBOARDING_STRIPE_DESCRIPTION:
        'ЗА ДА СВЪРЖЕТЕ СИСТЕМАТА ЗА ПЛАЩАНЕ, ТРЯБВА ДА СЪЗДАДЕТЕ АКАУНТ В STRIPE (ПЛАТФОРМА ЗА ОБРАБОТКА НА ПЛАЩАНИЯ)',
    ONBOARDING_GO_TO_STRIPE: 'ОТИДЕТЕ В STRIPE',
    ONBOARDING_STRIPE_SUCCESS: 'УСПЕШНО СЪЗДАДЕН АКАУНТ',
    ONBOARDING_OK: 'OK',
}

const months = {
    JANUARY: 'Януари',
    FEBRUARY: 'Февруари',
    MARCH: 'Март',
    APRIL: 'Април',
    MAY: 'Май',
    JUNE: 'Юни',
    JULY: 'Юли',
    AUGUST: 'Август',
    SEPTEMBER: 'Септември',
    OCTOBER: 'Октомври',
    NOVEMBER: 'Ноември',
    DECEMBER: 'Декември',
}

const shortMonths = {
    JAN: 'Ян',
    FEB: 'Февр',
    MAR: 'Март',
    APR: 'Апр',
    MAY: 'Май',
    JUN: 'Юни',
    JUL: 'Юли',
    AUG: 'Авг',
    SEP: 'Септ',
    OCT: 'Окт',
    NOV: 'Ноем',
    DEC: 'Дек',
}

const auth = {
    AUTH_CASHLESS_TIPS: 'CASHLESS TIPS',
    AUTH_UP_TO_40: 'До 40% повече бакшиши',
    AUTH_SIGNIN_OPTION: 'ВХОД',
    AUTH_SIGNUP_OPTION: 'РЕГИСТРАЦИЯ',
    AUTH_SIGNIN_TITLE: 'Вход',
    AUTH_SIGNUP_TITLE: 'Регистрация',
    AUTH_NAME: 'Име',
    AUTH_NAME_PLACEHOLDER: 'Въведете Вашето име',
    AUTH_ORGANIZATION: 'Организация',
    AUTH_ORGANIZATION_PLACEHOLDER: 'Въведете името на Вашата организация',
    AUTH_COUNTRY: 'Страна',
    AUTH_COUNTRY_PLACEHOLDER: 'Изберете държава от списъка',
    AUTH_COUNTRY_PLACEHOLDER_SHORT: 'Изберете държава',
    AUTH_PHONE: 'Телефон',
    AUTH_PHONE_PLACEHOLDER: 'Въведете Вашия телефонен номер',
    AUTH_EMAIL: 'E-mail',
    AUTH_EMAIL_PLACEHOLDER: 'Въведете Вашия имейл',
    AUTH_PASSWORD: 'Парола',
    AUTH_SIGNUP_PASSWORD_PLACEHOLDER: 'Съставете парола',
    AUTH_SIGNIN_PASSWORD_PLACEHOLDER: 'Въведете Вашата парола',
    AUTH_FORGOT_PASSWORD: 'Забравена парола?',
    AUTH_SOCIAL: 'Or use social media to sign in',
    AUTH_STRIPE_TOS:
        'Ние използваме Stripe, за да сме сигурни, че получавате плащания навреме и за да запазим вашите лични и банкови данни защитени.',
    AUTH_SELECT_LANGUAGE: 'Избери език',
    AUTH_CANCEL_BUTTON: 'ОТМЕНИ',
    AUTH_SIGNIN_BUTTON: 'ВХОД',
    AUTH_SIGNUP_BUTTON: 'РЕГИСТРАЦИЯ',
}

const home = {
    HOME_CURRENT_MONTH: 'Бакшиши за текущия месец',
    HOME_YEAR_TIPS: 'Бакшиши за годината',
    HOME_NPS: 'NPS',
    HOME_TOP_STAFF: 'Top staff',
    HOME_LAST_MONTH: 'last month',
    HOME_CASH_TIP: 'Cash tip',
    HOME_CASH_TIP_DESCRIPTION: 'Add cash tips to include in statistics',
    HOME_ADD_TIP_BUTTON: 'ADD TIP',
}

const statistics = {
    STATISTICS_CURRENT_MONTH: 'Общи бакшиши и оценка',
    STATISTICS_CURRENT_MONTH_RATING: 'Оценка',
    STATISTICS_YEAR_TIPS: 'Бакшиши за годината',
    STATISTICS_EMPLOYEES_TABLE_TITLE: 'Общи бакшиши по служители',

    STATISTICS_EMPLOYEES_TABLE_NO: 'No',
    STATISTICS_EMPLOYEES_TABLE_AVATAR: '',
    STATISTICS_EMPLOYEES_TABLE_NAME: 'Име',
    STATISTICS_EMPLOYEES_TABLE_ROLE: 'Роля',
    STATISTICS_EMPLOYEES_TABLE_RATING: 'Оценка',
    STATISTICS_EMPLOYEES_TABLE_TIPS: 'Бакшиши',

    STATISTICS_FEES_DISCLAIMER: "Моля, имайте предвид, че посочените цифри не включват такси и данъци.",
}
const qr = {
    QR_TITLE: 'QR КОДА',
    QR_DOWNLOAD: 'ДАУНЛОУД',
    QR_POSM: 'POSM',
    QR_STICKER: 'Стикер',
    QR_CARD: 'Карта',
    QR_TABLETOP: 'СТОЙКА НА МАСАТА',
    QR_STICKER_SIZE: 'Препоръчителен размер\n за печат 80x80mm',
    QR_CARD_SIZE: 'Препоръчителен размер\n за печат 80x80mm',
    QR_TABLETOP_SIZE: 'Препоръчителен размер\n за печат 148x210mm',
    QR_TAB_ORGANIZATION: 'QR код на организация',
    QR_TAB_EMPLOYEES: 'QR-кодове на служители',
    QR_REMOVE_EMPLOYEE: 'Премахване на служителя?',
    QR_BUTTON_REMOVE: 'ПРЕМАХВАНЕ',
    QR_BUTTON_CANCEL: 'ОТМЯНА',

    QR_SORT_PLACEHOLDER: 'Сортирай по',
    QR_SORT_BY_NAME: 'Име',
    QR_SORT_RATING: 'Оценка',
    QR_SORT_TIPS_AMOUNT: 'Размер на бакшишите',
    QR_SORT_EXPERIENCE: 'Трудов стаж',
    QR_EMPLOYEE_MODAL_ROLE_PLACEHOLDER: 'Изберете от списъка',
    QR_EMPLOYEE_MODAL_BIRTH_PLACEHOLDER_DAY: 'Ден',
    QR_EMPLOYEE_MODAL_BIRTH_PLACEHOLDER_MONTH: 'Месец',
    QR_EMPLOYEE_MODAL_BIRTH_PLACEHOLDER_YEAR: 'Година',
    QR_EMPLOYEE_MODAL_REMOVE_EMPLOYEE: 'Премахване на служителя',

    QR_EMPLOYEE_PHONE: 'Телефон',
    QR_EMPLOYEE_EMAIL: 'E-mail',

    QR_EMPLOYEE_MODAL_FULL_NAME: 'Пълно име',
    QR_EMPLOYEE_MODAL_FULL_NAME_PLACEHOLDER: 'Въведете пълното име',
    QR_EMPLOYEE_MODAL_DATE_OF_BIRTH: 'Дата на раждане',
    QR_EMPLOYEE_MODAL_DATE_OF_BIRTH_PLACEHOLDER: 'Въведете датата на раждане',
    QR_EMPLOYEE_MODAL_PHONE: 'Phone',
    QR_EMPLOYEE_MODAL_PHONE_PLACEHOLDER: 'Въведете телефон',
    QR_EMPLOYEE_MODAL_EMAIL: 'E-mail',
    QR_EMPLOYEE_MODAL_EMAIL_PLACEHOLDER: 'Въведете e-mail',
    QR_EMPLOYEE_MODAL_POSITION: 'Позиция',
    QR_EMPLOYEE_MODAL_POSITION_PLACEHOLDER: 'Изберете от списъка',
    QR_EMPLOYEE_MODAL_ADD_NEW: 'Добавете нов',
    QR_EMPLOYEE_MODAL_CANCEL_BUTTON: 'ОТМЯНА',
    QR_EMPLOYEE_MODAL_SAVE_BUTTON: 'ЗАПАЗЕТЕ',
}

const errors = {
    ERROR_DEFAULT: 'Нещо се обърка',
    ERROR_CODE_RESEND_WRONG_EMAIL: 'Грешен имейл',
    ERROR_CODE_RESEND_TOO_EARLY:
        'Повторното изпращане на код  е заявено твърде рано',
    ERROR_SESSION_EXPIRED: 'Вашата сесия е изтекла',
    ERROR_EMAIL_CODE_NOT_VALID: 'Кодът не е валиден',
    ERROR_EMAIL_IS_ALREADY_USED: 'Email is already used',
    ERROR_EMAIL_WRONG_CREDENTIALS: 'Wrong email or password',
}

const validationErrors = {
    VALIDATION_TOO_SHORT: 'Твърде кратък',
    VALIDATION_TOO_LONG: 'Твърде дълго',
    VALIDATION_INVALID_EMAIL: 'Грешен имейл',
    VALIDATION_NO_SPACE: 'Знакът за интервал не е позволен',
    VALIDATION_PHONE_FORMAT: 'Грешен формат на телефона',
}
const bg: Record<keyof typeof en, string> = {
    ...errors,
    ...validationErrors,
    ...language,
    ...country,
    ...months,
    ...shortMonths,
    ...header,

    ...onboarding,
    ...navigation,
    ...auth,
    ...home,
    ...qr,
    ...statistics,
} as const

export default bg
